module.exports = __webpack_public_path__ + "images/c75b4e1fc3cafd3a5ccb325422302f53-background.jpg";